import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Axios from "../../axiosInstance";
import { constantsApiEndpoints } from "../../../api";
import { toast } from "sonner";

// State that the response will be put into
const initialState = {
  occupations: null,
  isLoading: false,
  success: false,
  error: null,
};

// Async API call with Axios timeout
export const fetchOccupationsList = createAsyncThunk(
  "fetchOccupationsList",
  async (payload, { rejectWithValue }) => {
    try {
      console.log("Post occupations");
      const response = await Axios.post(`${constantsApiEndpoints.occupations}`, null, {
        timeout: 30000, // Set timeout to 30 seconds
      });
      return response.data;
    } catch (error) {
      if (error.code === 'ECONNABORTED') {
        // Handle timeout specific error
        return toast.error('Request timed out');
      }
      return toast.error(error.response?.data || 'An error occurred');
    }
  }
);

// Redux slice that contains the reducers/action calls
export const occupationsListSlice = createSlice({
  name: "Get Occupations List",
  initialState,
  reducers: {
    clearOccupationsListError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // FETCH OCCUPATIONS API
    builder.addCase(fetchOccupationsList.pending, (state, action) => {
      console.log("Pending", state.success);
      if (!state.occupations) {
        state.isLoading = true;
        state.success = false;
      }
    });
    builder.addCase(fetchOccupationsList.fulfilled, (state, action) => {
      state.success = true;
      console.log("Fulfilled", state.success);
      state.isLoading = false;
      state.error = null;
      state.occupations = action.payload;
    });
    builder.addCase(fetchOccupationsList.rejected, (state, action) => {
      state.isLoading = false;
      state.success = false;
      state.error = action.error?.message;
    });
  },
});

// SELECTORS which can be easily called to get the corresponding value
export const selectOccupations = (store) => store.occupationsList?.occupations;
export const selectOccupationsLoader = (store) => store?.occupationsList?.isLoading;
export const selectOccupationsSuccess = (store) => store?.occupationsList?.success;

// ACTIONS TO DISPATCH
export const { clearOccupationsListError } = occupationsListSlice.actions;

export default occupationsListSlice.reducer;